export { default } from './SuggestedBrandsList'
